import { Routes } from '@angular/router';
// import { OrderPage } from './orders/order-page/order-page';
// import { OrderSuccessPage } from './orders/order-success-page/order-success-page';
import { HomePage } from './home-page/home-page';
// import { BookATable } from './book-a-table/book-a-table';
// import { BookingSuccess } from './book-a-table/booking-success/booking-success';
// import { ProductDetailPage } from './products/product-detail-page/product-detail-page';
import { SEO_ROUTE_DATA } from './core/seo/seo-route-data';

export const routes: Routes = [
    {
        path: 'my-orders',
        loadComponent: () => import('./orders/my-orders-page/my-orders-page').then(m => m.MyOrdersPage),
        data: { seo: SEO_ROUTE_DATA.myOrders },
    },
    {
        path: 'order/:orderId/success',
        // component: OrderSuccessPage,
        loadComponent: () =>
            import('./orders/order-success-page/order-success-page').then(m => m.OrderSuccessPage),
        data: { seo: SEO_ROUTE_DATA.orderSuccess },
    },
    {
        path: 'order/:orderId/failure',
        loadComponent: () =>
            import('./orders/order-failure-page/order-failure-page').then(m => m.OrderFailurePage),
        data: { seo: SEO_ROUTE_DATA.orderFailure },
    },
    {
        path: 'order',
        loadComponent: () => import('./orders/order-page/order-page').then(m => m.OrderPage)
        // component: OrderPage
    },
    {
        path: 'bulk-snacks',
        loadComponent: () => import('./orders/order-page/order-page').then(m => m.OrderPage),
        data: { bulkSnacksOnly: true },
    },
    {
        path: 'about',
        loadComponent: () => import('./about-us/about-us').then(m => m.AboutUs)
    },
    {
        path: 'gallery',
        loadComponent: () => import('./gallery/gallery-page').then(m => m.GalleryPage)
    },
    {
        path: 'reviews',
        loadComponent: () => import('./reviews/reviews-page').then(m => m.ReviewsPage)
    },
    {
        path: 'work-with-us',
        loadComponent: () => import('./work-with-us/work-with-us').then(m => m.WorkWithUs)
    },
    {
        path: 'cookies',
        loadComponent: () =>
            import('./legal/cookies-policy/cookies-policy').then((m) => m.CookiesPolicy),
    },
    {
        path: 'privacy',
        loadComponent: () =>
            import('./legal/privacy-policy/privacy-policy').then((m) => m.PrivacyPolicy),
    },
    {
        path: 'privacy/facebook',
        loadComponent: () =>
            import('./legal/facebook-privacy/facebook-privacy').then((m) => m.FacebookPrivacy),
    },
    {
        path: 'privacy/instagram',
        loadComponent: () =>
            import('./legal/instagram-privacy/instagram-privacy').then((m) => m.InstagramPrivacy),
    },
    {
        path: 'auth/instagram-callback',
        loadComponent: () =>
            import('./core/auth/instagram-callback.component').then((m) => m.InstagramCallbackComponent),
        data: { seo: SEO_ROUTE_DATA.authCallback },
    },
    {
        path: 'terms-of-service',
        loadComponent: () =>
            import('./legal/terms-of-service/terms-of-service').then((m) => m.TermsOfService),
    },
    {
        path: 'reservation/:reservationId/success',
        // component: BookingSuccess
        loadComponent: () => import('./book-a-table/booking-success/booking-success').then(m => m.BookingSuccess),
        data: { seo: SEO_ROUTE_DATA.reservationSuccess },
    },
    {
        path: 'reservation/:reservationId/failure',
        loadComponent: () =>
            import('./book-a-table/reservation-error/reservation-error.component').then(
                (m) => m.ReservationErrorComponent,
            ),
        data: { seo: SEO_ROUTE_DATA.reservationFailure },
    },
    {
        path: 'table/:tableNo',
        loadComponent: () => import('./table/table-landing/table-landing').then((m) => m.TableLanding),
        data: { seo: SEO_ROUTE_DATA.tableLanding },
    },
    {
        path: 'table/:tableNo/bill',
        loadComponent: () => import('./table/table-bill/table-bill').then((m) => m.TableBill),
        data: { seo: SEO_ROUTE_DATA.tableBill },
    },
    {
        path: 'book-a-table/:reservationId/pre-order',
        // component: OrderPage
        loadComponent: () => import('./orders/order-page/order-page').then(m => m.OrderPage),
        data: { seo: SEO_ROUTE_DATA.preOrder },
    },
    {
        path: 'book-a-table',
        // component: BookATable
        loadComponent: () => import('./book-a-table/book-a-table').then(m => m.BookATable)
    },
    {
        path: 'products/:productId',
        loadComponent: () => import('./products/product-page/product-page').then(m => m.ProductPage)
    },
    {
        path: 'o/:slug',
        loadComponent: () =>
            import('./campaign/campaign-landing/campaign-landing').then((m) => m.CampaignLandingComponent),
        data: { seo: SEO_ROUTE_DATA.campaignRedirect },
    },
    {
        path: '',
        component: HomePage
    }

];